import { useContext } from "react";
import { useParams } from "react-router";
import { GuildRolesAndChannelContext } from "../../../sesh_router";

export function useRoles() {
	let { server_id } = useParams<{
		server_id: string;
	}>();

	const context = useContext(GuildRolesAndChannelContext);

	return context.get(server_id)?.roles;
}
